"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionBoxRemove = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.SelectionBoxRemove = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "selection-box-remove", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M100 400V360H40V300H0V380A20 20 0 0 0 20 400H100zM360 40V100H400V20A20 20 0 0 0 380 0H300V40H360zM0 100V20A20 20 0 0 1 20 0H100V40H40V100H0zM300 400V360H360V300H400V380A20 20 0 0 1 380 400H300zM240 400H160V360H240V400zM0 240V160H40V240H0zM400 160H360V240H400V160zM160 0V40H240V0H160zM120.02 179.86A20 20 0 1 0 120.02 219.86H280.0200000000001A20 20 0 0 0 280.0200000000001 179.86H120.02z" : "M200 280H120V320H200V280zM0 200V120H40V200H0zM120 0H200V40H120V0zM280 120V200H320V120H280zM20 320A20 20 0 0 1 0 300V240H40V280H80V320H20zM0 20V80H40V40H80V0H20A20 20 0 0 0 0 20zM300 0A20 20 0 0 1 320 20V80H280V40H240V0H300zM320 300V240H280V280H240V320H300A20 20 0 0 0 320 300zM100 140A20 20 0 0 0 100 180H220A20 20 0 1 0 220 140H100z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.SelectionBoxRemove.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.SelectionBoxRemove.displayName = "Blueprint5.Icon.SelectionBoxRemove";
exports.default = exports.SelectionBoxRemove;
//# sourceMappingURL=selection-box-remove.js.map